/** Default size (px) for the trailing TON icon. */
export const PRICE_BADGE_ICON_SIZE_PX = 20
